import { Box } from "@mui/material";

import { Text } from "../../../components/Text";

interface NavigationMenuSectionTitleMobileProps {
  children: React.ReactNode;
}

export function NavigationMenuSectionTitleMobile(props: NavigationMenuSectionTitleMobileProps) {
  const { children } = props;

  return (
    <Box display="flex" flexDirection="row" alignItems="center" paddingTop={3} paddingX={2}>
      <Text
        bold
        variant="body2"
        flexShrink={0}
        whiteSpace="nowrap1"
        sx={(theme) => ({
          color: theme.palette.navbar?.sectionTitle,
        })}
      >
        {children}
      </Text>
    </Box>
  );
}
